/**
 * [CurveBeamAI] What the BoneVue pipeline can read back from a saved segmentation.
 *
 * Single source for two things that must agree but are resolved independently:
 *
 *   1. the SEG store settings the viewer asks OHIF to produce
 *      (workflow preset customizations, and the aws-healthimaging data source
 *      override in CurveBeamAI/config/*.js)
 *   2. the pre-upload guard in convertNaturalizedReportToPart10Buffer, which
 *      checks the generated dataset actually came out this way
 *
 * The guard is not circular: it compares the *generated* dataset's SOPClassUID and
 * _meta.TransferSyntaxUID against this contract, so it still catches the preset not
 * being applied, a data source override winning, or an upstream default moving.
 *
 * OHIF 3.13 defaults SEG export to Label Map (1.2.840.10008.5.1.4.1.1.66.7) encoded
 * as RLE Lossless, which the pipeline cannot read — see
 * docs/guides/Segmentation-Frame-Length-Padding-Issue.md for how that surfaced.
 *
 * `sopClassUID` matches upstream's `BITMAP_SEG_SOP_CLASS_UID`
 * (extensions/cornerstone-dicom-seg/src/utils/segmentationConfig.ts). It is restated
 * here rather than imported because that package is not a CurveBeamAI dependency.
 */
export const BONEVUE_SEG_STORE = {
  /** `segmentation.store.defaultMode` — selects the binary SEG SOP class. */
  defaultMode: 'bitmap',
  /** Segmentation Storage — one bit per voxel. */
  sopClassUID: '1.2.840.10008.5.1.4.1.1.66.4',
  /** Explicit VR Little Endian — uncompressed. */
  transferSyntaxUID: '1.2.840.10008.1.2.1',
} as const;
